// Typelizer digest dc356141cdb0508193978a64be3d91a7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /team/members/:member_id/companies */
  update: (
    params: { memberId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/team/members/:member_id/companies', params, options),
    method: 'patch',
  }),
}
